import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import {
	EXTERNAL,
	INCASH_IFRAME,
	LOANS,
	LOANS_2,
	OFFERS,
	TEST_IFRAME,
	TEST_OFFERS,
} from '../../constants/constantApi';
import { getFormLinkWithParams } from '../../utils/getLinkWithSearchParams';
import { getFormLink } from '../../utils/getTld';
import { redirectToOfferwall } from '../../utils/offerwallRedirect';

export const Layout = ({children}: {children: any}) => {
	const location = useLocation();

	const host = window.location.host;
	const targetDomain = host.split('.')[0];
	const isOffers =
		targetDomain.includes(OFFERS)
		|| host.includes(TEST_OFFERS)
		|| targetDomain.includes(LOANS)
		|| targetDomain.includes(LOANS_2);

	const isForm = location.pathname === "/" + getFormLink();
	const isIframe = host.includes(TEST_IFRAME) || host.includes(EXTERNAL) || host.includes(INCASH_IFRAME);

	// Домены офферволла уводят на VITE_OFFERWALL_URL (или houston-frontend) + /offers: эту страницу отдаёт frontend-machine.
	useEffect(() => {
		if (isOffers) redirectToOfferwall();
	}, [isOffers]);

	if (isOffers) {
		return null;
	}

	if (isIframe && !isForm) {
		const formLink = getFormLinkWithParams(getFormLink(), window.location.search, true);
		return <Navigate to={formLink} state={{ isIframe: true }} replace />;
	}

	return children;
}
